import React from "react";

/** Custom logo for The Dyslexia Tutor:
 *  An open book whose pages curl into a sprouting plant — growth through literacy.
 *  Pairs with the "Td" wordmark in Fraunces. Uses brand terracotta + sage.
 */
export function LogoMark({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Open book base */}
      <path
        d="M6 46c8-4 16-4 26 0 10-4 18-4 26 0V20c-8-4-16-4-26 0-10-4-18-4-26 0v26z"
        fill="#FDFBF7"
        stroke="#1C2331"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      {/* Spine */}
      <path d="M32 20v26" stroke="#1C2331" strokeWidth="2.5" strokeLinecap="round" />
      {/* Sprout stem */}
      <path
        d="M32 20c0-4 0-8 0-12"
        stroke="#8AB0AB"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      {/* Left leaf */}
      <path
        d="M32 11c-3 0-6-1-7-4 3-1 6 0 7 4z"
        fill="#8AB0AB"
      />
      {/* Right leaf (terracotta accent) */}
      <path
        d="M32 8c3 0 6-1 7-4-3-1-6 0-7 4z"
        fill="#E06D53"
      />
      {/* Page lines (subtle, hint at letters) */}
      <path d="M14 32h12M14 38h10" stroke="#1C2331" strokeOpacity="0.35" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M38 32h12M40 38h10" stroke="#1C2331" strokeOpacity="0.35" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

export default function Logo({ className = "", showText = true, size = 40 }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
      <LogoMark size={size} />
      {showText && (
        <span className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-ink leading-none">
          The Dyslexia Tutor
        </span>
      )}
    </div>
  );
}
